import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=d1cd7ce8&shadow"
import script from "./Comment.vue?vue&type=script&lang=js&shadow"
export * from "./Comment.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./Comment.vue?vue&type=style&index=0&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports